<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
@font-face {
  font-family: "Noto IKEA";
  src: url("assets/fonts/NotoIKEALatin-Regular.woff");
  font-weight: normal;
}

@font-face {
  font-family: "Noto IKEA";
  src: url("assets/fonts/NotoIKEALatin-Bold.woff");
  font-weight: bold;
}

html,
body,
#app {
  font-family: "Noto IKEA", Verdana, Helvetica, Arial, sans-serif;
  color: #111;
  margin: 0px;
  padding: 0px;
  height: 100%;
  -webkit-touch-callout: none !important;
  -webkit-user-select: none !important;
  font-size: 13px;
}

* {
  box-sizing: border-box;
}

a:link {
  text-decoration: none;
}

input:focus,
textarea:focus,
select:focus {
  outline: none;
}

button {
  outline: none;
  border: none;
}

.full-width {
  width: 100%;
}
.centered {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.centered-text {
  text-align: center;
}
.flex-space-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flex-left-align {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.flex-right-align {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.seperator-line {
  height: 1px;
  background-color: rgb(242, 242, 242);
}

.bold {
  font-weight: bold;
}

.full-screen-overlay {
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
}

.primary-button {
  height: 54px;
  border-radius: 27px;
  line-height: 54px;
  font-size: 14rpx;
  font-weight: bold;
  background-color: #0058a3;
  color: #fff;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue